var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vwc-checkbox", {
    attrs: {
      checked: _vm.checked,
      indeterminate: _vm.indeterminate,
      disabled: _vm.disabled,
    },
    on: {
      change: function ($event) {
        return _vm.$emit("input", $event.target.checked)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }